import { CheckCircle2, AlertTriangle, Activity, TrendingUp, TrendingDown, Minus, Search, Heart, Moon, Utensils, Zap, Brain } from "lucide-react";

export const SEVERITY_META = {
  mild:     { label: "Mild",     cls: "bg-emerald-100 text-emerald-700 border-emerald-200", Icon: CheckCircle2 },
  moderate: { label: "Moderate", cls: "bg-amber-100 text-amber-700 border-amber-200",       Icon: AlertTriangle },
  expected: { label: "Expected", cls: "bg-sky-100 text-sky-700 border-sky-200",             Icon: Activity },
  painful:  { label: "Painful",  cls: "bg-red-100 text-red-700 border-red-200",             Icon: AlertTriangle },
  severe:   { label: "Severe",   cls: "bg-red-100 text-red-700 border-red-200",             Icon: AlertTriangle },
};

export const TREND_META = {
  improving:     { label: "Improving",    cls: "bg-emerald-100 text-emerald-700", Icon: TrendingUp },
  stable:        { label: "Stable",       cls: "bg-sky-100 text-sky-700",         Icon: Minus },
  expected:      { label: "Expected",     cls: "bg-violet-100 text-violet-700",   Icon: Activity },
  normal:        { label: "Normal",       cls: "bg-stone-100 text-stone-700",     Icon: CheckCircle2 },
  deteriorating: { label: "Deteriorating",cls: "bg-red-100 text-red-700",         Icon: TrendingDown },
  worsening:     { label: "Worsening",    cls: "bg-red-100 text-red-700",         Icon: TrendingDown },
  monitoring:    { label: "Monitoring",   cls: "bg-amber-100 text-amber-700",     Icon: Search },
};

// Maps backend `iconName` strings on wellness components → lucide React components.
export const ICON_MAP = { Activity, Brain, Heart, Moon, Utensils, Zap };
